import React, { FC } from "react";
import { IMetric } from "src/@types/users";

interface Props extends IMetric {}

export const MetricItem: FC<Props> = ({ title, value }) => (
  <div className="flex flex-col justify-center items-center px-5 text-lg text-center font-semibold border-r border-black-base/20 last:border-none first:pl-0 last:pr-0">
    <span>{value}</span>
    <span className="text-purple-base capitalize">{title}</span>
  </div>
);
